var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.68211C1.27215 8.68211 0.682107 9.27215 0.682107 10C0.682107 10.7279 1.27215 11.3179 2 11.3179L2 8.68211ZM23.9319 10.9319C24.4466 10.4172 24.4466 9.58278 23.9319 9.06811L15.5449 0.681089C15.0302 0.16642 14.1958 0.16642 13.6811 0.681089C13.1664 1.19576 13.1664 2.0302 13.6811 2.54487L21.1362 10L13.6811 17.4551C13.1664 17.9698 13.1664 18.8042 13.6811 19.3189C14.1958 19.8336 15.0302 19.8336 15.5449 19.3189L23.9319 10.9319ZM2 11.3179L23 11.3179V8.68211L2 8.68211L2 11.3179Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.efa7048f4e1fd502f80eb0645ec37871.svg";
export { ForwardRef as ReactComponent };